module.exports = __webpack_public_path__ + "static/media/overlay-x.8b267065.svg";